// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":host{display:inline-block;color:#000}.tag{border-radius:8px;font-size:15px;font-weight:600;padding:3px 10px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
